import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ConfirmDeleteComponent {

  message = 'Är du säker?';
  confirmButtonText = 'Ja';
  cancelButtonText = 'Avbryt';
  showRepayMoney = false;
  repayMoney = false;
  repayMoneyText = 'Repay Fee';

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmDeleteComponent>) {
    if (data) {
      this.message = data.message || this.message;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
      if (data.showRepayMoney) {
        this.showRepayMoney = true;
        this.repayMoney = !!data.repayMoneyDefault;
        if (data.repayMoneyText) {
          this.repayMoneyText = data.repayMoneyText;
        }
      }
    }
  }

  onConfirmClick(): void {
    if (this.showRepayMoney) {
      this.dialogRef.close({ confirmed: true, repayMoney: this.repayMoney });
    } else {
      this.dialogRef.close(true);
    }
  }

}
